import { render, staticRenderFns } from "./Accommodations.vue?vue&type=template&id=473b8e16&scoped=true&"
import script from "./Accommodations.vue?vue&type=script&lang=js&"
export * from "./Accommodations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b8e16",
  null
  
)

export default component.exports